<template>
  <div class="page">
    <el-form ref="form" :model="user" :rules="rules" label-width="100px">
      <el-form-item label="联系人：" prop="contract_name">
        <el-input v-model="user.contract_name" placeholder="请输入联系人" />
      </el-form-item>
      <el-form-item label="联系电话：" prop="contract_mobile">
        <el-input v-model="user.contract_mobile" placeholder="请输入联系电话" />
      </el-form-item>
      <el-form-item label="所在地区：" prop="province_city">
        <el-cascader style="width: 100%;" v-model="user.province_city" :options="treeList"
          @change="handleChange"></el-cascader>
      </el-form-item>
      <el-form-item label="收货地址：" prop="address">
        <el-input v-model="user.address" placeholder="请输入详细收货地址" />
      </el-form-item>
      <el-form-item label="物流要求：" prop="logistics_ids">
        <div style="display: flex;">
          <div v-if="oklist.length == 0" class="linput" @click="opencity">
            <div>
              请选择
            </div>
            <i class="el-icon-arrow-down"></i>
          </div>

          <div class="linputflex" v-else @click="opencity">
            <div class="flex_l">
              <div class="ites" v-for="(item, index) in oklist" :key="index">
                {{ item.name }} <span>，</span>
              </div>
            </div>
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div>
      <div class="z_btn" @click="submit">
        提交资料
      </div>
    </div>
    <el-dialog class="dialogs" title="选择物流" :visible.sync="showCity" width="660px">
      <div class="pop">
        <div class="pop_f">
          <div class="tit" v-for="(item, index) in cinfo" :key="index">
            {{ item[0].first_char }}
            <div class="cit">
              <div class="items" :class="its.isactive ? 'active' : ''" v-for="(its, ind) in item" :key="ind"
                @click="changeC(its, ind)">
                {{ its.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="pop_bot">
          <div style="font-size: 16px;">
            已选物流({{ oklist.length }}):
          </div>
          <div class="poprflex">
            <div class="items" v-for="(item, index) in oklist" :key="index">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCity = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import city from '@/utils/cityData.json'
import { getCitywuliu } from '@/api/user.js'
import { getUserInfo, saveUserInfo } from '@/api/user.js'
export default {
  name: '',
  data() {
    return {
      user: {
        contract_name: undefined,
        contract_mobile: undefined,
        province_city: '',
        address: undefined,
        logistics_ids: undefined,
      },
      rules: {
        contract_name: [
          { required: true, message: "联系人不能为空", trigger: "blur" }
        ],
        contract_mobile: [
          { required: true, message: "联系电话不能为空", trigger: "blur" }
        ],
        province_city: [
          { required: true, message: "所在地区不能为空", trigger: "blur" }
        ],
        address: [
          { required: true, message: "收货地址不能为空", trigger: "blur" }
        ],
        logistics_ids: [
          { required: true, message: "物流要求不能为空", trigger: "blur" }
        ]
      },
      treeList: [],
      showCity: false,
      value: '',
      cinfo: {},
      asd: '请选择',
      oklist: [],
    }
  },
  mounted() {
    this.getuser()
    city.forEach((item) => {
      this.treeList.push(this.getModuleObject(item));
    });
    //获取物流数据
    getCitywuliu().then(res => {
      res.data.forEach(item => {
        // 第二层  判断item 在不在会显得数据里面
        item.forEach(its => {
          its.isactive = false
        })
      })
      this.cinfo = res.data
    })
  },
  methods: {
    // 上来拿一次数据，若果有就赋值没有就新增
    getuser() {
      getUserInfo().then(res => {
        this.$store.commit('SetUserinfo', res.data)
        if (res.data.address) {
          this.user.contract_name = res.data.contract_name
          this.user.contract_mobile = res.data.contract_mobile
          this.user.province_city = res.data.province_city.split("/")
          this.user.address = res.data.address
          this.user.logistics_ids = res.data.logistics_ids
          this.oklist = res.data.logistics_datas
        }
      })

    },
    opencity() {
      this.cinfo.forEach(item => {
        // 第二层  判断item 在不在会显得数据里面
        item.forEach(its => {
          let as = this.oklist.find((i) => i.id == its.id)
          if (as) {
            its.isactive = true
          } else {
            its.isactive = false
          }
        })
      })
      this.showCity = true

    },
    changeC(its, ind) {
      its.isactive = !its.isactive
      const result = this.oklist.some((item) => item.id == its.id);
      if (its.isactive) {
        if (result) {} else {this.oklist.push(its) }
      } else {
        this.oklist = this.oklist.filter(item => {
          return item.id != its.id
        })
      }
    },
    handleConfirm() {
      this.showCity = false
    },
    handleChange(e) {
      this.user.province_city = e
    },
    submit() {
      this.user.province_city = this.user.province_city.join('/')
      this.user.logistics_ids = this.oklist.map(item => { return item.id }).join(',')
      this.$refs["form"].validate(valid => {
        if (valid) {
          saveUserInfo(this.user).then(res => {
            if (res.code == 1) {
              this.$modal.msgSuccess(`资料提交成功`);
              this.getuser()
            }
          })
        }
      });
    },
    getModuleObject(obj) {
      if (!obj.s) {
        return {
          label: obj.n,
          value: obj.n,
          children: null,
        };
      }
      const temp = { label: obj.n, value: obj.n, children: [], };
      obj.s.forEach((item) => {
        temp.children.push(this.getModuleObject(item));
      });
      return temp;
    }
  },
}
</script>
<style lang='scss' scoped>
.z_btn {
  margin-top: 80px;
  margin-left: 900px;
}
.page {
  padding: 30px;
  box-sizing: border-box;
  min-height: 600px;

}

.linput {
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #999999;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.linputflex {
  display: flex;
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
  align-items: center;
  justify-content: space-between;

  .flex_l {
    width: 800px;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .ites:last-child span {
      display: none;
    }

  }
}

.pop {
  .pop_f {
    height: 400px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(144, 147, 153, 0.3);
      cursor: pointer;
      border-radius: 4px;
    }
  }

  .tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #000000;
    margin-bottom: 20px;

    .cit {
      margin-top: 12px;
      display: flex;
    }

    .items {
      margin-right: 44px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #000000;
      cursor: pointer;
    }

    .active {
      color: #FF9500;
    }
  }

  .pop_bot {
    border-top: 1px solid #DEDEDE;
    padding-top: 20px;
    display: flex;

    .poprflex {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
    }

    .items {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      margin-left: 10px;
      color: #FF9500;

    }
  }
}
</style>